import {getAllCityHexKeys} from "./getAllCityHexKeys";

/**
 * Проверяет, принадлежит ли строение на указанной ячейке городу игрока
 * 
 * @param {string} hexKey - Ключ ячейки строения в формате "q,r"
 * @param {string} playerColor - Цвет игрока
 * @param {Object} citiesCache - Кэш городов { [playerColor]: [city1, city2, ...] }
 * @returns {boolean} True если казарма принадлежит городу игрока, иначе false
 */
export const checkIfOwner = (hexKey, playerColor, citiesCache) => {
  // Находим игрока по ID
  const playerCities = citiesCache[playerColor] || [];
  
  // Проверяем каждый город игрока
  for (const city of playerCities) {
    const cityHexes = getAllCityHexKeys(city);
    if(cityHexes.find(i => i === hexKey)) {
      return true; // Ячейка принадлежит городу игрока
    }
  }
  
  // Казарма не найдена ни в одном городе игрока
  return false;
};